import { buildVolleyballLiveMobileProps } from "../buildVolleyballMobileProps";
import { getBackgroundImage } from "../../helpers";
export const buildVolleyballLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildVolleyballLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildVolleyballLiveDesktopProps.js.map